import { render, staticRenderFns } from "./Communication.vue?vue&type=template&id=463a8ccb&scoped=true"
import script from "./Communication.vue?vue&type=script&lang=js"
export * from "./Communication.vue?vue&type=script&lang=js"
import style0 from "./communication/Communication.scss?vue&type=style&index=0&id=463a8ccb&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a8ccb",
  null
  
)

export default component.exports